import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import {
  media,
  color,
  toCurrency,
  getValue,
  mapState,
} from '@deerplusofficial/pos-helper';
import { Calculator } from '@deerplusofficial/pos-components';
import { connect } from 'react-redux';
import { withCheckout } from '../../model/Mutations';
import Info from '../Info/Info';
import InfoSection from '../Info/InfoSection';
import InfoSectionPoints from '../Info/InfoSectionPoints';
import InfoSectionWrapper from '../Info/InfoSectionWrapper';
import InfoWithCalculatorInput from '../InfoWithCalculatorInput/InfoWithCalculatorInput';
import MemberActions from '../MemberActions/MemberActions';
import TabContent from './TabContent';
import CheckoutButton from './CheckoutButton';

export const CalculatorWrapper = styled.div`
  ${media(
    'tablet',
    css`
      width: 50%;
    `
  )};
`;

const ErrorMessage = styled.div`
  margin-top: 16px;
  font-size: 12px;
  color: ${color.text.error};
  text-align: right;
  ${media(
    'tablet',
    css`
      margin-top: 0;
    `
  )};
`;

class CashTab extends React.PureComponent {
  static propTypes = {
    order: PropTypes.shape(),
    meta: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      })
    ),
  };

  static defaultProps = {
    order: {},
    meta: [],
  };

  state = {
    cash: toCurrency(0),
  };

  onCalculatorRef = element => (this.calculator = element);

  onCalculatorKeyDown = e => this.calculator.onButtonPress(e);

  onChange = cash => this.setState({ cash });

  onSubmit = () => {
    const { onCheckout, meta } = this.props;
    const { cash } = this.state;
    const methodId = _.get(...meta, 'id');

    onCheckout({
      methodId,
      cashAmount: String(getValue(cash)),
    });
  };

  get exchange() {
    const {
      order: { price, points },
    } = this.props;
    const { cash } = this.state;
    return getValue(cash) + points - price;
  }

  get isShowError() {
    const { cash } = this.state;
    return this.exchange < 0 && getValue(cash) !== 0;
  }

  render() {
    const {
      order: { submitting },
    } = this.props;
    const { cash } = this.state;

    return (
      <React.Fragment>
        <TabContent>
          <InfoSectionWrapper>
            {this.isShowError && (
              <ErrorMessage>請輸入大於或等於結帳金額的數字</ErrorMessage>
            )}
            <InfoSectionPoints />
            <InfoSection>
              <InfoWithCalculatorInput
                label="收取現金"
                value={cash}
                onKeyDown={this.onCalculatorKeyDown}
              />
            </InfoSection>
            <InfoSection>
              <Info
                label="找零"
                positive={this.exchange > 0}
                negative={this.exchange < 0}
              >
                {toCurrency(this.exchange)}
              </Info>
            </InfoSection>
            <MemberActions />
          </InfoSectionWrapper>
          <CalculatorWrapper>
            <Calculator
              large
              ref={this.onCalculatorRef}
              value={cash}
              onChange={this.onChange}
            />
          </CalculatorWrapper>
        </TabContent>
        <CheckoutButton
          loading={submitting}
          disabled={this.exchange < 0}
          onClick={this.onSubmit}
        />
      </React.Fragment>
    );
  }
}

export default fp.compose(
  withCheckout(),
  connect(mapState(['order']))
)(CashTab);



// WEBPACK FOOTER //
// ./src/components/CheckoutPanel/CashTab.js